(function () {

  // ========== CONFIGURATION ==========
  const INSURANCE_HANDLE = 'insurance-product';
  const MANUAL_REMOVE_FLAG = 'autoInsuranceRemoved';

  // ========== STATE ==========
  let isProcessing = false;
  let isCheckboxProcessing = false;
  let insuranceProduct = null;

  // ========== UTIL ==========
  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    return res.json();
  }

  async function getCart() {
    return fetchJSON('/cart.js');
  }

  async function getInsuranceProduct() {
    if (insuranceProduct) return insuranceProduct;
    insuranceProduct = await fetchJSON(`/products/${INSURANCE_HANDLE}.js`);
    return insuranceProduct;
  }

  function updateCheckboxState(checked, skipEvent = false) {
    const cb = document.querySelector('#insurance-checkbox');
    if (!cb) return;

    cb.checked = checked;

    if (!skipEvent) {
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ========== MODAL ==========
  function showRemovalModal() {
    return new Promise(resolve => {

        document.body.style.overflow = 'hidden';

      const html = `
      <div id="insurance-removal-modal" style="
        position:fixed; inset:0; background:rgba(0,0,0,.5);
        display:flex; align-items:center; justify-content:center; z-index:9999;">
        <div style="background:#fff; padding:25px; max-width:80%; border-radius:8px; border-radius: 8px;
    text-align: center;">
          <p>
            By choosing to disable Shipping Insurance, you acknowledge that Arctic Scent is not responsible for any loss, damage, or theft that may occur during transit. In the event of such incidents, claims must be filed directly with the shipping carrier.

<br><br>If Shipping Insurance is enabled, Arctic Scent will assist with claims and ensure full coverage under our protection policy.
          </p>
          <button id="ins-yes" style="padding: 10px 15px;
    color: white;
    background: #25394c;
    border: 0;
    border-radius: 5px;">Remove Insurance</button>
          <button id="ins-no"  style="padding: 10px 15px;
    color: white;
    background: #25394c;
    border: 0;
    border-radius: 5px;">Keep Insurance</button>
        </div>
      </div>`;

      document.body.insertAdjacentHTML('beforeend', html);

      const modal = document.getElementById('insurance-removal-modal');

      modal.querySelector('#ins-yes').onclick = () => {
        modal.remove();
        document.body.style.overflow = '';
        resolve(true);
      };

      modal.querySelector('#ins-no').onclick = () => {
        modal.remove();
        document.body.style.overflow = '';
        resolve(false);
      };

    });
  }

  // ========== INSURANCE VARIANT ==========
  function getCorrectVariant(product, subtotal) {
    let title = '';

    if (subtotal <= 250) title = 'Below $250';
    else if (subtotal <= 550) title = 'Below $550';
    else title = 'Above $550';

    return product.variants.find(v => v.title === title)
      || product.variants[0];
  }

  async function modifyCart(action, data) {
    await fetch(`/cart/${action}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(data)
    });

    await new Promise(r => setTimeout(r, 500));
  }

  // ========== MAIN INSURANCE ==========
  async function manageInsurance() {

    if (isProcessing) return;
    isProcessing = true;

    try {

      const [cart, product] = await Promise.all([
        getCart(),
        getInsuranceProduct()
      ]);

      const subtotal = cart.items_subtotal_price / 100;
      const correctVariant = getCorrectVariant(product, subtotal);

      const insuranceItem = cart.items.find(
        i => i.handle === INSURANCE_HANDLE
      );

      const hasOtherItems = cart.items.some(
        i => i.handle !== INSURANCE_HANDLE
      );

      const manuallyRemoved =
        sessionStorage.getItem(MANUAL_REMOVE_FLAG) === 'true';

      updateCheckboxState(!!insuranceItem, true);

      // AUTO ADD
      if (hasOtherItems && !insuranceItem && !manuallyRemoved) {
        await modifyCart('add', {
          id: correctVariant.id,
          quantity: 1
        });
        updateCheckboxState(true, true);
        location.reload();
      }

      // AUTO REMOVE
      if (!hasOtherItems && insuranceItem) {
        await modifyCart('change', {
          id: insuranceItem.key,
          quantity: 0
        });
        updateCheckboxState(false, true);
        location.reload();
      }

      // UPDATE TIER
      if (
        insuranceItem &&
        insuranceItem.variant_id !== correctVariant.id
      ) {
        await modifyCart('change', {
          id: insuranceItem.key,
          quantity: 0
        });

        await modifyCart('add', {
          id: correctVariant.id,
          quantity: 1
        });

        location.reload();
      }

    } finally {
      isProcessing = false;
    }
  }

  // ========== CHECKBOX ==========
  async function handleCheckboxChange(e) {

    if (isCheckboxProcessing) return;
    isCheckboxProcessing = true;

    const checked = e.target.checked;

    try {

      const cart = await getCart();
      const insuranceItem =
        cart.items.find(i => i.handle === INSURANCE_HANDLE);

      if (checked) {
        sessionStorage.removeItem(MANUAL_REMOVE_FLAG);
        if (!insuranceItem) {
          await manageInsurance();
        }
      } else {

        const ok = await showRemovalModal();

        if (!ok) {
          updateCheckboxState(true, true);
          return;
        }

        if (insuranceItem) {
          sessionStorage.setItem(MANUAL_REMOVE_FLAG, 'true');

          await modifyCart('change', {
            id: insuranceItem.key,
            quantity: 0
          });

          location.reload();
        }
      }

    } finally {
      isCheckboxProcessing = false;
    }
  }

  // ========== INIT ==========
  function init() {

    const cb = document.querySelector('#insurance-checkbox');

    if (cb) {
      cb.addEventListener('change', handleCheckboxChange);
    }

    manageInsurance();
  }

  document.addEventListener('DOMContentLoaded', init);

})();
